module.exports = __webpack_public_path__ + "static/img/detail3.169a182c.png";